import {
    Repository,
    WizDocument,
    DocumentOperateData,
    Department,
    MemberCountType,
} from '@/interface';
export type NodeIdType = string | number;

export type NodeIcon = (props: React.SVGProps<SVGSVGElement>) => React.PropsWithoutRef<React.ReactSVGElement>;

// 根层级的parentGuid默认值
export const ROOT_PARENT_GUID = '00000000000000';

export interface PageIndexProps {
    isPersonalKb: boolean;
    isRecycleBin: boolean;
    isSetting: boolean;
    isHomeTag: boolean;
    isMemberManage: boolean;
    isKuShareMode?: boolean;
    repository: Repository | null;
    docGuid?: string;
    curDocument?: WizDocument;
    curDocuments?: WizDocument[];
    documentOperate?: DocumentOperateData;
    curDepartment?: Department;
    membersCount?: MemberCountType;
    repoPermissionRiskCount?: number;
    isShowSidebar?: boolean; // 是否需要刷新左侧边栏
}

export enum RootNodeId {
    Home = 'home',
    DocumentIndex = 'documentIndex',
    RecycleBin = 'recycleBin',
    Setting = 'setting',
    Tag = 'homeTag',
    Member = 'members',
    QACenter = 'QACenter',
    // 谁能想到，这里居然是要跟路由的后缀保持一致的T^T
    // 天坑啊！！！定位一小时，代码改动一行T^T………
    SquareRecommend = 'square',
    CommonDoc = 'commonDoc',
}
export interface sideBarRootNode {
    id: RootNodeId;
    isSelected?: boolean;
    icon?: NodeIcon | null;
    text: string | React.ReactNode;
    url?: string;
    origin?: any;
    enableSelected?: boolean;
    visible?: boolean; // 是否展示本节点, 不填默认是true
    contentRender?: ((options?: any) => React.ReactElement);
    isTop?: boolean; // 是否吸顶
    isDisable?: boolean; // 是否禁用, 展示灰色图标
}

export interface TreeNodeData {
    id: NodeIdType;
    parentId?: NodeIdType;
    treeId?: string;
    url?: string;
    text: string;
    isLeaf: boolean;
    icon?: NodeIcon | null;
    isExpanded?: boolean;
    isSelected?: boolean;
    enableDrag?: boolean;
    enableClick?: boolean;
    enableSelected?: boolean;
    hideArrow?: boolean;
    children?: TreeNodeData[];
    origin?: any;
    type?: string| number;
    parentType?: string | number;
    tagName?: string;
    inheritRepo?: number;
    docGuid?: string;
    childCount?: number;
    name?: string;
    contentRender?: (options?: any) => React.ReactElement;
}
